import request from "@/utils/request";

// 获取模型列表
export function getModelList(params) {
  return request({
    url: "/3d/model/list",
    method: "get",
    params,
  });
}

// 上传模型
export function uploadModel(data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: "/3d/model/upload",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 删除模型
export function deleteModel(params) {
  return request({
    url: "/3d/model/delete",
    method: "delete",
    params,
  });
}

// 获取场景列表
export function getSceneList(params) {
  return request({
    url: "/3d/scene/list",
    method: "get",
    params,
  });
}

// 获取场景详情
export function getSceneDetail(params) {
  return request({
    url: "/3d/scene/detail",
    method: "get",
    params,
  });
}

// 保存场景（新建）
export function saveScene(data) {
  return request({
    url: "/3d/scene/save",
    method: "post",
    data,
  });
}

// 更新场景
export function updateScene(data) {
  return request({
    url: "/3d/scene/update",
    method: "post",
    data,
  });
}

// 发布场景
export function publishScene(data) {
  return request({
    url: "/3d/scene/publish",
    method: "post",
    data,
  });
}

// 删除场景
export function deleteScene(params) {
  return request({
    url: "/3d/scene/delete",
    method: "delete",
    params,
  });
}

// 获取场景变量数据
export function getSceneVariables(params) {
  return request({
    url: "/3d/scene/variables",
    method: "get",
    params,
  });
}
